import React from "react";
import { Distributions } from "../modules/DistributionsBOH";

export function DistributionsListPage(props) {
  return <Distributions {...props} />;
}
